import { configureStore } from "@reduxjs/toolkit";
// settings
import settings from "../features/settings/Slice";

// auth
import auth from "../features/auth/Slice";

// common
import common from "../features/admin/common/Slice";

// masters
import masters from "./masters";

import aboutus from "./aboutus";

import customers from "./customers";

import management from "./management";

import usermanagement from "./usermanagement";
import games from "./games";
import support from "../features/support/slice";

import subscription from "../features/admin/subscription/slice";
import wallet from "../features/admin/wallet/slice";
import funtarget from "./funtarget";
import roulette from "./roulette";

export const store = configureStore({
  reducer: {
    // settings
    settings: settings,
    //auth
    auth: auth,
    //common
    common: common,
    //masters
    masters,
    //aboutus
    aboutus,
    //customers
    customers,

    usermanagement,

    subscription: subscription,
    wallet: wallet,

    games,
    support,

    //
    management,

    funtarget,
    roulette,
  },
});
